<template>
  <span ref="trigger">
    <slot></slot>
    <transition :name="effect">
      <div ref="popover" v-show="show && popoverCondition" :class="['popover',placement,classes]" :style="popoverStyle" :id='id'>
        <div class="arrow"  :style="arrowStyle"></div>
        <h3 class="popover-title" v-if="title" :style="textStyle"><slot name="title">{{title}}</slot>
          <div style="float:right; cursor: pointer;" @click="ok_close">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#292c34" /></svg>
          </div>
        </h3>
        <div class="popover-content" :style="textStyle"><slot name="content"><span v-html="content"></span></slot></div>
        <div>
            <button v-if="showNO" class="btn btn-danger btn-sm" style="float: left; margin: 5px" @click="no_close">{{no_text}}</button>
            <button v-if="showOK" class="btn btn-primary-default btn-sm" style="float: right; margin: 5px" @click="ok_close">{{ok_text}}</button>
        </div>  
      </div>
    </transition>
  </span>
</template>

<script>
import PopoverMixin from './utils/popoverMixins.js'

export default {
  mixins: [PopoverMixin],
  props: {
    trigger: {
        type: String, 
        default: 'click'
    },
    arrowStyle: {type: Object},
    popoverStyle: {type: Object},
    textStyle: {type: Object},
    classes: {type: String},

    ok: {
        type: Function,
        default() {
            return null;
        }
    },
    no: {
        type: Function,
        default() {
            return null;
        }
    },
    popoverCondition: {
        type: Boolean,
        default: true
    },
    ok_text: {type: String, default: ''},
    no_text: {type: String, default: ''},
    showOK: {type: Boolean, default: true},
    showNO: {type: Boolean, default: true},
    id: String
  },
  methods: {
      close: function(){
          this.toggle();
      },
      no_close: function(){
          this.no();
          this.close();
      },
      ok_close: function(){
          this.ok();
          this.close();
      }
  }
}
</script>

<style>
.popover.top,
.popover.left,
.popover.right,
.popover.bottom {
  display: block;
}
.popover.autoleft {
  left: auto !important;
}
.popover.autotop {
  top: auto !important;
}
.popover.zerotop {
  top: 5px !important;
}
.popover.in_sidebar {
  top: 70px !important;
  left: 55px !important;
}
.popover.bottom {
  bottom: 50px !important;
}
.errorArrow > .arrow:after {
  border-right-color: #f2dede !important;
}
.scale-enter {
  animation:scale-in 0.15s ease-in;
}
.scale-leave-active {
  animation:scale-out 0.15s ease-out;
}
@keyframes scale-in {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes scale-out {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dynamic/popoverWrapper/Popover.vue?7116c212